var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54996 16.3717C6.04103 15.594 3.93884 13.8603 2.69764 11.5454C1.45643 9.23044 1.17589 6.52009 1.91663 4C4.5129 4.11881 7.05343 3.22215 8.99996 1.5C10.9465 3.22215 13.487 4.11881 16.0833 4C16.6489 5.92426 16.6227 7.97412 16.0083 9.88333M11.5 14.8333L13.1666 16.5L16.5 13.1667",
    stroke: "#CCCCCC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.b34574839722e8c02038e905e492b776.svg";
export { ForwardRef as ReactComponent };